export default __webpack_public_path__ + "images/EV.3b98de4.png";